import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-[var(--bg-dark)] py-20 px-4" data-id="element-50">
      <div className="max-w-4xl mx-auto" data-id="element-51">
        <motion.div className="bg-[var(--bg-card)] rounded-2xl p-8 md:p-12 border-2 border-[var(--accent-orange)]" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-52">
          <div className="flex flex-col items-center text-center" data-id="element-53">
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2,
            duration: 0.6
          }} data-id="element-54">
              <ShieldCheckIcon className="w-20 h-20 md:w-24 md:h-24 text-[var(--accent-orange)] mb-6" aria-hidden="true" data-id="element-55" />
            </motion.div>

            <motion.h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-[var(--text-light)] mb-6" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3,
            duration: 0.6
          }} data-id="element-56">
              Garantía "Ámalo o Déjalo"
            </motion.h2>

            <motion.div className="space-y-4 mb-8" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} data-id="element-57">
              <p className="text-xl md:text-2xl text-[var(--text-light)]" data-id="element-58">
                Tienes{' '}
                <span className="font-bold text-[var(--accent-orange)]" data-id="element-59">
                  7 días completos
                </span>{' '}
                para probar el método.
              </p>
              <p className="text-lg md:text-xl text-[var(--text-gray)]" data-id="element-60">
                Si no te gusta… Si no es para ti… Si simplemente cambias de
                opinión…
              </p>
              <p className="text-xl md:text-2xl font-bold text-[var(--text-light)]" data-id="element-61">
                Escribes y te devolvemos el dinero.
              </p>
              <p className="text-lg md:text-xl text-[var(--text-gray)]" data-id="element-62">
                Sin preguntas incómodas.
              </p>
            </motion.div>
          </div>
        </motion.div>

        <motion.div className="mt-16 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} data-id="element-63">
          <h3 className="text-3xl md:text-4xl font-black text-[var(--accent-orange)] mb-6" data-id="element-64">
            Pero Atención
          </h3>
          <p className="text-xl md:text-2xl text-[var(--text-light)] mb-4" data-id="element-65">
            No voy a mantener este precio para siempre.
          </p>
          <p className="text-lg md:text-xl text-[var(--text-gray)] mb-6" data-id="element-66">
            Me reservo el derecho de subirlo o cerrar el acceso cuando lo
            considere.
          </p>
          <p className="text-xl md:text-2xl font-bold text-[var(--text-light)] mb-8" data-id="element-67">
            Porque este no es un hobby barato.
            <br data-id="element-68" />
            <span className="text-[var(--accent-orange)]" data-id="element-69">
              Es una habilidad que puede convertirse en ingreso real.
            </span>
          </p>

          <div className="space-y-4 mb-12" data-id="element-70">
            <p className="text-lg md:text-xl text-[var(--text-gray)]" data-id="element-71">
              Si quieres dejar de improvisar…
            </p>
            <p className="text-lg md:text-xl text-[var(--text-gray)]" data-id="element-72">
              Si quieres empezar con seguridad…
            </p>
            <p className="text-lg md:text-xl text-[var(--text-gray)]" data-id="element-73">
              Si quieres tener un sistema claro…
            </p>
          </div>

          <p className="text-2xl md:text-3xl font-bold text-[var(--text-light)] mb-8" data-id="element-74">
            Haz clic abajo y empieza hoy mismo.
          </p>

          <CTAButton size="large" data-id="element-75">EMPEZAR AHORA</CTAButton>

          <p className="text-xl md:text-2xl text-[var(--accent-orange-light)] font-bold mt-8" data-id="element-76">
            Tu primer lote exitoso está más cerca de lo que crees.
          </p>
        </motion.div>
      </div>
    </section>;
}